import ShopRegions from 'utils/shop-regions';

const regions = new ShopRegions({
  setSitesFromHreflangs: true,
  redirectIfHasSelected: true,
});

regions.shouldRedirect().then((shouldRedirect) => {
  if (shouldRedirect) {
    regions.doAutomaticRedirect();
  }
});

export default regions;
